import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Elevator = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5C5 2.79086 6.79086 1 9 1H16C18.2091 1 20 2.79086 20 5V19C20 21.2091 18.2091 23 16 23H9C6.79086 23 5 21.2091 5 19V5ZM9 3C7.89543 3 7 3.89543 7 5V19C7 20.1046 7.89543 21 9 21H16C17.1046 21 18 20.1046 18 19V5C18 3.89543 17.1046 3 16 3H9Z"
        fill="currentColor"
      />
      <path
        d="M12.097 6.21986L10.0912 9.1874C9.85962 9.52684 10.0962 10 10.4953 10H14.5068C14.906 10 15.1376 9.53198 14.9109 9.1874L12.9052 6.21986C12.708 5.92671 12.2941 5.92671 12.097 6.21986Z"
        fill="currentColor"
      />
      <path
        d="M12.097 17.7801L10.0912 14.8126C9.85962 14.4732 10.0962 14 10.4953 14H14.5068C14.906 14 15.1376 14.468 14.9109 14.8126L12.9052 17.7801C12.708 18.0733 12.2941 18.0733 12.097 17.7801Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Elevator;
